import { fontSize, fontWeight, letterSpacing } from '@/src/core/utils/typography';
import { Ionicons } from '@expo/vector-icons';
import { Image, StyleSheet, Text, TouchableOpacity, View } from 'react-native';

export interface UserCardProps {
  userId: string;
  userName?: string;
  userEmail?: string;
  userAvatarUrl?: string;
  actions?: React.ReactNode;
  onPress?: () => void;
  colors: {
    card: string;
    border: string;
    text: string;
    textSecondary: string;
    shadow: string;
  };
}

export const UserCard = ({
  userId,
  userName,
  userEmail,
  userAvatarUrl,
  actions,
  onPress,
  colors,
}: UserCardProps) => {
  const displayName = userName || userEmail || 'Unknown User';
  const displayEmail = userName ? userEmail : undefined;

  return (
    <TouchableOpacity
      style={[styles.container, { backgroundColor: colors.card, borderColor: colors.border, shadowColor: colors.shadow }]}
      onPress={onPress}
      activeOpacity={0.7}
      disabled={!onPress}
    >
      <View style={styles.leftSection}>
        {userAvatarUrl ? (
          <Image source={{ uri: userAvatarUrl }} style={styles.avatar} />
        ) : (
          <View style={[styles.avatarPlaceholder, { backgroundColor: colors.border }]}>
            <Ionicons name="person" size={24} color={colors.textSecondary} />
          </View>
        )}
        <View style={styles.textContainer}>
          <Text style={[styles.name, { color: colors.text }]} numberOfLines={1}>
            {displayName}
          </Text>
          {displayEmail && (
            <Text style={[styles.email, { color: colors.textSecondary }]} numberOfLines={1}>
              {displayEmail}
            </Text>
          )}
        </View>
      </View>
      {actions && <View style={styles.actionsContainer}>{actions}</View>}
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: 12,
    borderRadius: 8,
    borderWidth: 1,
    marginBottom: 8,
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 1,
    shadowRadius: 4,
    elevation: 2,
  },
  leftSection: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
    marginRight: 12,
  },
  avatar: {
    width: 48,
    height: 48,
    borderRadius: 24,
    marginRight: 12,
  },
  avatarPlaceholder: {
    width: 48,
    height: 48,
    borderRadius: 24,
    marginRight: 12,
    alignItems: 'center',
    justifyContent: 'center',
  },
  textContainer: {
    flex: 1,
  },
  name: {
    fontSize: fontSize.md,
    fontWeight: fontWeight.semibold,
    letterSpacing: letterSpacing.tight,
    marginBottom: 2,
  },
  email: {
    fontSize: fontSize.base,
  },
  actionsContainer: {
    flexDirection: 'row',
    gap: 8,
  },
});
